module.exports = __webpack_public_path__ + "static/media/27OCHA14.03d9f904.jpg";